import styled from 'styled-components'

export const Container = styled.div`
    color: #18182D;
    background-color: #18182D;
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Content = styled.div`
  max-width: 36rem;
`

export const Logo = styled.img`
    width: 12.5rem;
    margin: 0.75rem 0 1.5rem;
    transform: translateX(0.825rem);
`

export const MainContentContainer = styled.div`
    background-color: white;
    padding: 1.5rem 3rem 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border-radius: 4px;

    h4 {
        font-size: 1.1rem;
        font-weight: 600;
        color: #18182d;
        margin: 1rem 0 1.5rem;
    }
`

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 0.75rem;

    a {
        display: block;
        text-decoration: none;
        border-radius: 8px;
    }
`

export const SupportMessageContainer = styled.div`
    color: white;
    text-align: center;
    margin-top: 1.8rem;

    a {
        color: white;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    p {
        margin: 0;
    }
`

